var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.52002C6.04406 0.52002 0 6.56408 0 14.02C0 21.476 6.04406 27.52 13.5 27.52C20.9559 27.52 27 21.476 27 14.02C27 6.56408 20.9559 0.52002 13.5 0.52002ZM10.1953 19.6155H7.46156V10.818H10.1953V19.6155ZM8.81156 9.73799C7.94812 9.73799 7.38984 9.12627 7.38984 8.36971C7.38984 7.59768 7.965 7.00424 8.84672 7.00424C9.72844 7.00424 10.2684 7.59768 10.2853 8.36971C10.2853 9.12627 9.72844 9.73799 8.81156 9.73799ZM20.1797 19.6155H17.4459V14.74C17.4459 13.6052 17.0494 12.8346 16.0608 12.8346C15.3056 12.8346 14.857 13.3563 14.6588 13.8583C14.5856 14.0369 14.5673 14.29 14.5673 14.5417V19.6141H11.8322V13.6235C11.8322 12.5252 11.797 11.6069 11.7605 10.8166H14.1356L14.2608 12.0386H14.3156C14.6756 11.4649 15.5573 10.6183 17.0325 10.6183C18.8311 10.6183 20.1797 11.8235 20.1797 14.4138V19.6155Z",
    fill: "#7D95D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.db733dc17acb60a900ffbdc6686dacc6.svg";
export { ForwardRef as ReactComponent };